import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '='
    },
    template: '<manage-permissions-roles-form role="vm.role" form="vm.form"/>'
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.role, model => model.$update({ id: model.id }));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/roles/detail/privileges/index.js